export const SET_SOCIAL_ENTITIES = 'setSocialEntities'
